import { useRepo, Model } from "pinia-orm";
import Client from "./Client";
import User from "./User";
import Agency from "./Agency";
import Mission from "../Mission";

export default class Case extends Model {
  static name = "Case";
  static primaryKey = "caseNumber";

  static fields() {
    return {
      uuid: this.uid(""),
      caseNumber: this.attr(""),
      caseName: this.attr(""),
      caseAgencyCode: this.attr(""),
      label: this.attr(""),
      status: this.attr(""),
      opeStartDate: this.attr(""),
      postcode: this.attr(""),
      city: this.attr(""),
      address: this.attr(""),
      isArchived: this.boolean(false),
      rictPublicationDate: this.attr(""),
      initialAmount: this.attr(""),
      finalAmount: this.attr(""),
      estimatedDuration: this.attr(""),
      signDate: this.attr(""),
      totalBeforeTax: this.attr(""),
      isNationalContract: this.boolean(false),
      facturationCalculMode: this.attr(""),
      caseManagerCode: this.attr(""),
      managerFirstName: this.attr(""),
      managerLastName: this.attr(""),
      managerEmail: this.attr(""),
      managerUsermanagementUuid: this.uid(""),
      manager: this.belongsTo(User, "managerUsermanagementUuid", "usermanagementUuid"),
      orderedSince: this.attr(""),
      closedSince: this.attr(""),
      clientUuid: this.attr(""),
      client: this.belongsTo(Client, "clientUuid"),
      projects: this.hasMany(Mission, "caseNumber", "caseNumber"),
      contractingAgency: this.belongsTo(Agency, "caseAgencyCode", "code"),
      updatedAt: this.attr(""),
      createAt: this.attr(""),

      // Rapsotec fields
      forcedStatus: this.attr(""),
      userProfileId: this.attr(""), // Foreign key
      clientLabel: this.attr(""),
      contractingAgencyCode: this.attr(""),
      emittedDocs: this.attr(""),
      userUuid: this.attr(""),
    };
  }

  static createFromListerData(data) {
    const CaseRepo = useRepo(this);
    CaseRepo.save({
      uuid: data.caseUuid,
      caseNumber: data.caseNumber,
      label: data.rapsoCaseLabel || data.caseLabel,
      city: data.rapsoCaseCity || data.caseCity,
      address: data.caseAddress,
      status: data.caseStatus,
      clientUuid: data.clientUuid,
      updatedAt: data.caseUpdatedAt,
      manager: data.caseManager,
      managerEmail: data.caseManager?.email,
      managerUsermanagementUuid: data.caseManager?.usermanagementUuid,
      caseAgencyCode: data.caseAgencyCode,
    });
  }
}
